import type { TFunction } from 'i18next'

/**
 * AP-29-N — Wie ein Baustein oder Modul **heißt**.
 *
 * Drei Quellen, in dieser Reihenfolge:
 *
 * 1. Die **Vertriebsbezeichnung** aus dem Katalog — was der Betreiber ohne
 *    Deployment festgelegt hat.
 * 2. Die **i18n-Vorgabe** (`modules.names.<KEY>`) — gepflegt von der
 *    Entwicklung, in beiden Sprachen.
 * 3. Der **Schlüssel** selbst — nur, wenn beides fehlt. Das ist kein Zustand,
 *    den ein Kunde sehen soll, aber besser als eine leere Zelle.
 *
 * Dieser Helfer liegt in `lib/`, weil ihn vier Seiten brauchen: die Modulseite
 * des Mandanten, die Preisliste, die Paket-Maske und die Betreiber-Konsole.
 * Stünde die Reihenfolge viermal im Code, hieße derselbe Posten irgendwann an
 * zwei Stellen verschieden — und das fällt niemandem auf, der nur eine davon
 * offen hat.
 */
export function moduleLabel(
  key: string,
  t: TFunction,
  salesNames?: Readonly<Record<string, string | null | undefined>>,
): string {
  const vertrieb = salesNames?.[key]
  if (vertrieb) return vertrieb

  // `t` gibt bei einem fehlenden Schlüssel den Schlüssel zurück — dann liegt für
  // diesen Posten keine Übersetzung vor, und der rohe Modulschlüssel ist die
  // ehrlichere Anzeige als „modules.names.X".
  const i18nKey = `modules.names.${key}`
  const uebersetzt = t(i18nKey)
  return uebersetzt === i18nKey ? key : uebersetzt
}
